import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { fg } from '@atlaskit/platform-feature-flags';
import getPageVisibilityUpToTTAI from '../../../create-payload/utils/get-page-visibility-up-to-ttai';
import { getInteractionId } from '../../../interaction-id-context';
import { interactions } from '../../../interaction-metrics/common/constants';
import { cssIssueOccurrence } from '../viewport-observer/utils/track-display-content-occurrence';
import { calculateTTVCPercentilesWithDebugInfo } from './percentile-calc';
import getViewportHeight from './utils/get-viewport-height';
import getViewportWidth from './utils/get-viewport-width';

// Create comprehensive debug details including ignored entries
var AbstractVCCalculatorBase = /*#__PURE__*/function () {
  function AbstractVCCalculatorBase(revisionNo) {
    _classCallCheck(this, AbstractVCCalculatorBase);
    this.revisionNo = revisionNo;
  }
  return _createClass(AbstractVCCalculatorBase, [{
    key: "filterViewportEntries",
    value: function filterViewportEntries(entries) {
      return entries.filter(function (entry) {
        return 'rect' in entry.data;
      });
    }

    /**
     * Calculate ratios for each element based on their viewport coverage.
     */
  }, {
    key: "calculateRatios",
    value: function calculateRatios(filteredEntries) {
      var ratios = {};
      var viewportWidth = getViewportWidth();
      var viewportHeight = getViewportHeight();
      var totalViewportArea = viewportWidth * viewportHeight;
      if (totalViewportArea === 0) {
        return ratios;
      }
      var elementRects = new Map();
      var _iterator = _createForOfIteratorHelper(filteredEntries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _entry = _step.value;
          if ('rect' in _entry.data) {
            var viewportEntry = _entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(elementRects),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            elementName = _step2$value[0],
            rect = _step2$value[1];
          var elementArea = rect.width * rect.height;
          ratios[elementName] = elementArea / totalViewportArea;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return ratios;
    }
  }, {
    key: "getLabelStacks",
    value: function getLabelStacks(filteredEntries) {
      var labelStacks = {};
      var _iterator3 = _createForOfIteratorHelper(filteredEntries),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _entry2 = _step3.value;
          if ('elementName' in _entry2.data && _entry2.data.labelStacks) {
            labelStacks[_entry2.data.elementName] = {
              segment: _entry2.data.labelStacks.segment,
              labelStack: _entry2.data.labelStacks.labelStack
            };
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return labelStacks;
    }
  }, {
    key: "calculateWithDebugInfo",
    value: function () {
      var _calculateWithDebugInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionId, dirtyReason, allEntries, include3p) {
        var _window, _window2, _window3, _window5;
        var percentiles, viewportEntries, vcLogs, vcDetails, percentileIndex, entryDataBuffer, _iterator4, _step4, _entry3, time, viewportPercentage, entries, elementNames, previousResult, i, percentile, enhancedVcLogs, shouldCalculate3p, shouldCalculateDebugDetails, sortedVcLogs, maxViewportPercentageAtTime, maxSoFar, _iterator5, _step5, log, getBiggestPreviousViewportPercentage, ignoredEntriesByTime, _iterator6, _step6, _entry4, _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou, viewportData, timestamp, additionalVcLogs, _iterator7, _step7, _step7$value, _timestamp, ignoredEntries, _viewportPercentage, v3RevisionDebugDetails, _activeInteractionId$, activeInteractionId, activeInteraction, pageVisibilityUpToTTAI, isBackgrounded, _window4, _window4$__ufo_devtoo, _window6, _window6$__on_ufo_vc_;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              percentiles = [25, 50, 75, 80, 85, 90, 95, 98, 99, 100];
              viewportEntries = this.filterViewportEntries(filteredEntries);
              _context.next = 4;
              return calculateTTVCPercentilesWithDebugInfo({
                viewport: {
                  width: getViewportWidth(),
                  height: getViewportHeight()
                },
                startTime: startTime,
                stopTime: stopTime,
                orderedEntries: viewportEntries
              });
            case 4:
              vcLogs = _context.sent;
              vcDetails = {};
              percentileIndex = 0;
              entryDataBuffer = new Set();
              if (!vcLogs) {
                _context.next = 28;
                break;
              }
              _iterator4 = _createForOfIteratorHelper(vcLogs);
              _context.prev = 10;
              _iterator4.s();
            case 12:
              if ((_step4 = _iterator4.n()).done) {
                _context.next = 20;
                break;
              }
              _entry3 = _step4.value;
              time = _entry3.time, viewportPercentage = _entry3.viewportPercentage, entries = _entry3.entries; // Only process entries if we haven't reached all percentiles
              if (!(percentileIndex >= percentiles.length)) {
                _context.next = 17;
                break;
              }
              return _context.abrupt("break", 20);
            case 17:
              // Check if this entry matches any checkpoint percentiles
              if (viewportPercentage >= percentiles[percentileIndex]) {
                elementNames = entries.map(function (e) {
                  return e.elementName;
                }); // Process all matching percentiles in one go
                while (percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]) {
                  vcDetails["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(time),
                    e: elementNames
                  };
                  percentileIndex++;
                }

                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
              } else {
                // Only add to buffer if we haven't reached all percentiles
                entries.forEach(function (e) {
                  return entryDataBuffer.add(e);
                });
              }
            case 18:
              _context.next = 12;
              break;
            case 20:
              _context.next = 25;
              break;
            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](10);
              _iterator4.e(_context.t0);
            case 25:
              _context.prev = 25;
              _iterator4.f();
              return _context.finish(25);
            case 28:
              // Fill in any missing percentiles with the last known values
              previousResult = {
                t: 0,
                e: []
              };
              for (i = 0; i < percentiles.length; i++) {
                percentile = percentiles[i];
                if (!(percentile in vcDetails)) {
                  vcDetails["".concat(percentile)] = previousResult;
                } else {
                  previousResult = vcDetails["".concat(percentile)];
                }
              }
              enhancedVcLogs = vcLogs ? vcLogs.map(function (log) {
                return _objectSpread(_objectSpread({}, log), {}, {
                  entries: log.entries.map(function (entry) {
                    var _entry$rect, _entry$previousRect;
                    return _objectSpread(_objectSpread({}, entry), {}, {
                      rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                      previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                    });
                  }),
                  viewportPercentage: log.viewportPercentage
                });
              }) : []; // If 3p metric enabled - calculate the debug details
              shouldCalculate3p = include3p && fg('platform_ufo_enable_ttai_with_3p'); // Only calculate enhanced debug details if devtool callbacks exist
              shouldCalculateDebugDetails = (!isPostInteraction || shouldCalculate3p) && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function');
              if (shouldCalculateDebugDetails && allEntries && vcLogs) {
                // Pre-sort vcLogs by time for efficient lookups
                sortedVcLogs = _toConsumableArray(vcLogs).sort(function (a, b) {
                  return a.time - b.time;
                }); // Pre-calculate max viewport percentage up to each time for efficient lookups
                maxViewportPercentageAtTime = new Map();
                maxSoFar = 0;
                _iterator5 = _createForOfIteratorHelper(sortedVcLogs);
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    log = _step5.value;
                    if (log.viewportPercentage !== null) {
                      maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                      maxViewportPercentageAtTime.set(log.time, maxSoFar);
                    }
                  }

                  // Helper function to find the biggest previous viewport percentage
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
                getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
                  // Binary search for the largest time <= targetTime
                  var left = 0;
                  var right = sortedVcLogs.length - 1;
                  var result = -1;
                  while (left <= right) {
                    var mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                      result = mid;
                      left = mid + 1;
                    } else {
                      right = mid - 1;
                    }
                  }
                  return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
                }; // Group ignored entries by timestamp
                ignoredEntriesByTime = new Map();
                _iterator6 = _createForOfIteratorHelper(allEntries);
                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    _entry4 = _step6.value;
                    if ('rect' in _entry4.data && !this.isEntryIncluded(_entry4, include3p)) {
                      viewportData = _entry4.data;
                      timestamp = Math.round(_entry4.time);
                      if (!ignoredEntriesByTime.has(timestamp)) {
                        ignoredEntriesByTime.set(timestamp, []);
                      }
                      (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push(_objectSpread(_objectSpread({}, viewportData), {}, {
                        rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                        previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                        ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                      }));
                    }
                  }

                  // Add ignored entries to vcLogs
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
                additionalVcLogs = [];
                _iterator7 = _createForOfIteratorHelper(ignoredEntriesByTime);
                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    _step7$value = _slicedToArray(_step7.value, 2), _timestamp = _step7$value[0], ignoredEntries = _step7$value[1];
                    if (ignoredEntries.length > 0) {
                      _viewportPercentage = getBiggestPreviousViewportPercentage(_timestamp);
                      additionalVcLogs.push({
                        time: _timestamp,
                        viewportPercentage: _viewportPercentage,
                        entries: ignoredEntries
                      });
                    }
                  }

                  // Combine and sort all vcLogs
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }
                enhancedVcLogs = [].concat(_toConsumableArray(enhancedVcLogs), additionalVcLogs).sort(function (a, b) {
                  return a.time - b.time;
                });
              }

              // Only create debug details if callbacks exist
              v3RevisionDebugDetails = null;
              if (shouldCalculateDebugDetails) {
                if (fg('platform_ufo_unify_abort_status_in_ttvc_debug_data')) {
                  // NOTE: using this instead of directly calling `getActiveInteraction()` to get around circular dependencies
                  activeInteractionId = getInteractionId();
                  activeInteraction = interactions.get((_activeInteractionId$ = activeInteractionId.current) !== null && _activeInteractionId$ !== void 0 ? _activeInteractionId$ : '');
                  pageVisibilityUpToTTAI = activeInteraction ? getPageVisibilityUpToTTAI(activeInteraction) : null;
                  isBackgrounded = pageVisibilityUpToTTAI !== 'visible';
                  v3RevisionDebugDetails = {
                    revision: this.revisionNo,
                    isClean: isVCClean && !(activeInteraction !== null && activeInteraction !== void 0 && activeInteraction.abortReason) && !isBackgrounded,
                    abortReason: isBackgrounded ? 'browser_backgrounded' : dirtyReason !== null && dirtyReason !== void 0 ? dirtyReason : activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.abortReason,
                    vcLogs: enhancedVcLogs,
                    interactionId: interactionId
                  };
                } else {
                  v3RevisionDebugDetails = {
                    revision: this.revisionNo,
                    isClean: isVCClean,
                    abortReason: dirtyReason,
                    vcLogs: enhancedVcLogs,
                    interactionId: interactionId
                  };
                }
              }

              // Handle devtool callback
              if (v3RevisionDebugDetails && typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) {
                try {
                  (_window4 = window) === null || _window4 === void 0 || (_window4$__ufo_devtoo = _window4.__ufo_devtool_onVCRevisionReady__) === null || _window4$__ufo_devtoo === void 0 || _window4$__ufo_devtoo.call(_window4, v3RevisionDebugDetails);
                } catch (e) {
                  // if any error communicating with devtool, we don't want to break the app
                  // eslint-disable-next-line no-console
                  console.error('Error in onVCRevisionReady', e);
                }
              }
              if (v3RevisionDebugDetails && typeof ((_window5 = window) === null || _window5 === void 0 ? void 0 : _window5.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) {
                try {
                  (_window6 = window) === null || _window6 === void 0 || (_window6$__on_ufo_vc_ = _window6.__on_ufo_vc_debug_data_ready) === null || _window6$__on_ufo_vc_ === void 0 || _window6$__on_ufo_vc_.call(_window6, v3RevisionDebugDetails);
                } catch (e) {
                  // eslint-disable-next-line no-console
                  console.error('Error in onVCRevisionReady', e);
                }
              }
              if (v3RevisionDebugDetails && shouldCalculate3p) {
                try {
                  // Log vc details with 3p for debugging
                  window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
                } catch (e) {
                  // eslint-disable-next-line no-console
                  console.error('Error in 3pDebugData', e);
                }
              }
              return _context.abrupt("return", vcDetails);
            case 40:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[10, 22, 25, 28]]);
      }));
      function calculateWithDebugInfo(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
        return _calculateWithDebugInfo.apply(this, arguments);
      }
      return calculateWithDebugInfo;
    }()
  }, {
    key: "calculate",
    value: function () {
      var _calculate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
        var _this = this,
          _vcDetails$90$t,
          _vcDetails$;
        var startTime, stopTime, orderedEntries, interactionId, isPostInteraction, include3p, filteredEntries, isVCClean, dirtyReason, getVCCleanStatusResult, vcDetails, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries, interactionId = _ref.interactionId, isPostInteraction = _ref.isPostInteraction, include3p = _ref.include3p;
              filteredEntries = orderedEntries.filter(function (entry) {
                return _this.isEntryIncluded(entry, include3p);
              });
              getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
              isVCClean = getVCCleanStatusResult.isVCClean;
              dirtyReason = getVCCleanStatusResult.dirtyReason;
              if (isVCClean) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", {
                revision: this.revisionNo,
                'metric:vc90': null,
                clean: false,
                abortReason: dirtyReason,
                abortTimestamp: getVCCleanStatusResult.abortTimestamp
              });
            case 7:
              _context2.next = 9;
              return this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionId, dirtyReason, orderedEntries, include3p);
            case 9:
              vcDetails = _context2.sent;
              result = {
                revision: this.revisionNo,
                clean: true,
                'metric:vc90': (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null,
                vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined
              };
              result.ratios = this.calculateRatios(filteredEntries);
              if (isPostInteraction) {
                result.labelStacks = this.getLabelStacks(filteredEntries);
              }
              if (fg('platform_ufo_display_content_track_occurrence')) {
                result.displayContentsOccurrence = cssIssueOccurrence;
              }
              return _context2.abrupt("return", result);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function calculate(_x0) {
        return _calculate.apply(this, arguments);
      }
      return calculate;
    }()
  }]);
}();
export { AbstractVCCalculatorBase as default };